import {UnsavedGuard} from "../services/unsaved-guard.service";

declare const __mongos: string[];


export interface IDynamicRouteData {
  target: string;
}


/*
 Не получается добавлять роуты динамически, поэтому они добавлены в appComponent
 и добавлена инициализация в app-module.ts!
 entryComponents: [ProfilesRootPageComponent, ProfilesPageComponent]
 */
export function getPageChildRoutes(component) {
  let result = [];
  for (let i = 0; i < __mongos.length; ++i) {
    result.push(createRoute(__mongos[i], component));
  }
  return result;
}


export function createRoute(name, component) {
  return {
    path: name,
    component: component,
    canDeactivate: [UnsavedGuard],
    data: {name: name, target: name}
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/routing/dynamic-routing.module.ts